import * as React from "react";
import * as _ from "lodash";
import {LeaderboardConfig, BonusConfigListRequest} from "../../../../generated/protocol";
import {EntityDataTable} from "../../list/EntityDataTable";
import {Form, FormListener} from "../../form/Form";
import {FormGroup} from "../../form/FormGroup";
import {FormInput} from "../../form/FormInput";
import {Validators} from "../../form/Validators";
import {ListViewState, ListViewProps, ListView, createInitialState} from "../ListView";
import {BonusService, BONUS_SERVICE_NAME} from "../../../service/bonus/BonusService";
import {kernel} from "../../../ioc/IOCHelper";
import {RequiresAdminRole} from "../../util/RequiresAdminRole";


interface FilterForm {
    operatorId?: number;
}

interface State extends ListViewState<BonusConfigListRequest> {
    listRequest?: BonusConfigListRequest;
    form?: FilterForm;
    validationMap?: any;
}

export class BonusConfigListView extends ListView<State, BonusConfigListRequest> implements FormListener<FilterForm> {

    bonusService: BonusService;

    columns = [
        {property: "nameId", name: "Name ID", orderBy: "nameId"},
        {property: "name", name: "Name", orderBy: "name"}
    ];
    actions = [
        {id: "show", name: "Show", className: "btn btn-primary", iconClassName: "fa fa-eye"}
    ];

    constructor(props: ListViewProps) {
        super(props, "/bonuses");
        this.state = createInitialState({orderBy: "nameId"}, this.state);
        this.bonusService = kernel.get<BonusService>(BONUS_SERVICE_NAME);
    }

    formDidUpdate(formModel: FilterForm, validationMap: any) {
        this.setState({form: formModel, validationMap: validationMap});
    }

    onSubmit() {
        var listRequest = _.clone(this.state.listRequest);
        listRequest.operatorId = this.state.form.operatorId;
        this.updateListState(listRequest);
    }

    onSubmitError() {
    }

    onAction(item: LeaderboardConfig, action: string) {
        if (action == "show") {
            this.navigate("/bonus/show/" + item.id);
        }
    }

    renderContent() {
        return (
            <div>
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col-lg-12">
                        <h1>Bonus Configurations</h1>
                    </div>
                </div>
                <div className="wrapper wrapper-content animated">
                    <RequiresAdminRole>
                        <div className="ibox float-e-margins">
                            <div className="ibox-title">
                                <h5>Filter Bonuses</h5>
                            </div>
                            <div className="ibox-content">
                                <Form className="form-horizontal" formListener={this} modelObject={this.state.form}
                                      validationMap={this.state.validationMap}>
                                    <FormGroup className="form-group" model="operatorId">
                                        <label className="col-lg-2 control-label">Operator ID:</label>
                                        <div className="col-lg-10">
                                            <FormInput className="form-control" model="operatorId"
                                                       validators={[Validators.integer()]}/>
                                            <span className="help-block m-b-none">Operator id</span>
                                        </div>
                                    </FormGroup>
                                    <div className="form-group">
                                        <div className="col-lg-offset-2 col-lg-10">
                                            <input className="btn btn-primary" value="Apply" type="submit"/>
                                        </div>
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </RequiresAdminRole>

                    <EntityDataTable service={this.bonusService}
                                     columns={this.columns}
                                     actions={this.actions}
                                     listRequest={this.state.listRequest}
                                     onPagerChange={this.pagerChanged.bind(this)}
                                     onAction={this.onAction.bind(this)}/>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/ui/view/bonus/BonusConfigListView.tsx